import { render, staticRenderFns } from "./MenuCreateDialog.vue?vue&type=template&id=5568a748"
import script from "./MenuCreateDialog.vue?vue&type=script&lang=js"
export * from "./MenuCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports